import React, { Fragment } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { colors } from '../../utils/portfolioData';
// Modern blue/purple color scheme with milky glass aesthetic
const data = [{
  name: 'Bitcoin',
  value: 51.23,
  color: '#8B5CF6',
  glowColor: 'rgba(139, 92, 246, 0.6)'
}, {
  name: 'Ethereum',
  value: 24.87,
  color: '#6366F1',
  glowColor: 'rgba(99, 102, 241, 0.6)'
}, {
  name: 'USDT',
  value: 15.45,
  color: '#3B82F6',
  glowColor: 'rgba(59, 130, 246, 0.6)'
}, {
  name: 'Solana',
  value: 5.78,
  color: '#A78BFA',
  glowColor: 'rgba(167, 139, 250, 0.6)'
}, {
  name: 'BNB',
  value: 2.67,
  color: '#818CF8',
  glowColor: 'rgba(129, 140, 248, 0.6)'
}];
export function AllocationChart() {
  return <div className="h-full flex flex-col" data-id="element-305">
      <div className="flex items-center justify-between mb-6" data-id="element-306">
        <h3 className="text-base font-heading text-text-primary tracking-tight" data-id="element-307">
          Portfolio Allocation
        </h3>
        <button className="text-sm text-brand-purple-lighter hover:text-brand-purple-light transition-colors font-ui" data-id="element-308">
          View Details
        </button>
      </div>

      <div className="flex-1 flex flex-col gap-8" data-id="element-309">
        {/* Half Circle Chart - Clean Approach */}
        <div className="w-full h-32 relative flex items-end justify-center" data-id="element-310">
          <ResponsiveContainer width="100%" height="100%" data-id="element-311">
            <PieChart data-id="element-312">
              <defs data-id="element-313">
                {data.map(entry => <Fragment key={entry.name} data-id="element-314">
                    {/* Single gradient per segment - from vibrant to subtle */}
                    <linearGradient id={`gradient-${entry.name}`} x1="0" y1="0" x2="0" y2="1" data-id="element-315">
                      <stop offset="0%" stopColor={entry.color} stopOpacity="0.9" data-id="element-316" />
                      <stop offset="100%" stopColor={entry.color} stopOpacity="0.3" data-id="element-317" />
                    </linearGradient>

                    {/* Soft glow filter */}
                    <filter id={`glow-${entry.name}`} x="-50%" y="-50%" width="200%" height="200%" data-id="element-318">
                      <feGaussianBlur in="SourceGraphic" stdDeviation="6" data-id="element-319" />
                      <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 0.6 0" data-id="element-320" />
                      <feBlend in="SourceGraphic" mode="normal" data-id="element-321" />
                    </filter>
                  </Fragment>)}
              </defs>
              <Pie data={data} cx="50%" cy="100%" startAngle={180} endAngle={0} innerRadius={60} outerRadius={90} paddingAngle={0} dataKey="value" stroke="none" data-id="element-322">
                {data.map((entry, index) => <Cell key={`cell-${index}`} fill={`url(#gradient-${entry.name})`} filter={`url(#glow-${entry.name})`} stroke={entry.color} strokeWidth={1} strokeOpacity={0.5} style={{
                filter: `drop-shadow(0 0 12px ${entry.glowColor})`
              }} data-id="element-323" />)}
              </Pie>
              <Tooltip content={({
              active,
              payload
            }) => {
              if (!active || !payload || !payload.length) return null;
              const data = payload[0];
              return <div style={{
                background: 'rgba(20, 22, 32, 0.65)',
                backdropFilter: 'blur(32px) saturate(180%)',
                WebkitBackdropFilter: 'blur(32px) saturate(180%)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: '20px',
                padding: '16px 20px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.08)'
              }} data-id="element-325">
                      <div style={{
                  color: '#9CA3AF',
                  fontSize: '11px',
                  marginBottom: '10px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  fontWeight: '400'
                }} data-id="element-326">
                        {data.name}
                      </div>
                      <div style={{
                  color: '#FFFFFF',
                  fontSize: '28px',
                  fontWeight: '300',
                  letterSpacing: '-0.02em'
                }} data-id="element-327">
                        {data.value.toFixed(2)}%
                      </div>
                    </div>;
            }} cursor={false} wrapperStyle={{
              zIndex: 1000
            }} data-id="element-324" />
            </PieChart>
          </ResponsiveContainer>
          {/* Center Text */}
          <div className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center pointer-events-none z-10" style={{
          bottom: '0px'
        }} data-id="element-328">
            <span className="text-3xl font-light text-text-primary font-numbers" style={{
            letterSpacing: '-0.02em'
          }} data-id="element-329">
              100%
            </span>
            <span className="text-xs text-text-tertiary uppercase tracking-wider font-label mt-0.5" data-id="element-330">
              Total
            </span>
          </div>
        </div>

        {/* Legend */}
        <div className="space-y-3" data-id="element-331">
          {data.map(item => <div key={item.name} className="flex items-center justify-between px-3 py-2 rounded-lg hover:bg-background-elevated/30 transition-all duration-200 cursor-pointer group" data-id="element-332">
              <div className="flex items-center gap-3" data-id="element-333">
                <div className="relative" data-id="element-334">
                  <div className="w-3.5 h-3.5 rounded-sm flex-shrink-0 transition-all duration-200 group-hover:scale-110" style={{
                background: `linear-gradient(135deg, ${item.color} 0%, ${item.color}dd 100%)`
              }} data-id="element-335" />
                </div>
                <span className="text-sm font-medium text-text-primary group-hover:text-text-primary transition-colors" data-id="element-336">
                  {item.name}
                </span>
              </div>
              <span className="font-numbers text-sm font-semibold text-text-primary tabular-nums" data-id="element-337">
                {item.value.toFixed(2)}%
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}